@media screen and (min-width: 980px) {
  :host {
    flex: 0 0 280px;
  }
}

.responsive-filters__mobile {
  margin-top: 24px;
  min-height: 50px;
}

@media screen and (min-width: 980px) {
  .responsive-filters__mobile {
    display: none;
  }
}

@media screen and (max-width: 979px) {
  .responsive-filters__desktop:not(.responsive-filters__desktop--visible) {
    display: none;
  }
}

.responsive-filters {
  --se-primary: #3dcd58;
  --se-primary-rgb: 61, 205, 88;
  --se-secondary: #42b4e6;
  --se-secondary-rgb: 66, 180, 230;
  --se-standard: #626469;
  --se-standard-rgb: 98, 100, 105;
  --se-alternative: #ffffff;
  --se-alternative-rgb: 255, 255, 255;
  --se-success: #3dcd58;
  --se-success-rgb: 61, 205, 88;
  --se-information: #0087cd;
  --se-information-rgb: 0, 135, 205;
  --se-warning: #e47f00;
  --se-warning-rgb: 228, 127, 0;
  --se-error: #dc0a0a;
  --se-error-rgb: 220, 10, 10;
  --se-border: #9fa0a4;
  --se-border-rgb: 159, 160, 164;
  --se-disabled: #9fa0a4;
  --se-disabled-rgb: 159, 160, 164;
  --se-border-focus: #333333;
  --se-border-focus-rgb: 51, 51, 51;
  --se-divider: #e6e6e6;
  --se-divider-rgb: 230, 230, 230;
  --se-link-color: #0087CD;
  --se-link-color-rgb: 0, 135, 205;
  --se-link-visited: #3a738c;
  --se-link-visited-rgb: 58, 115, 140;
  --se-primary-contrast: #ffffff;
  --se-primary-contrast-rgb: 255, 255, 255;
  --se-secondary-contrast: #ffffff;
  --se-secondary-contrast-rgb: 255, 255, 255;
  --se-standard-contrast: #ffffff;
  --se-standard-contrast-rgb: 255, 255, 255;
  --se-alternative-contrast: #333333;
  --se-alternative-contrast-rgb: 51, 51, 51;
  --se-success-contrast: #ffffff;
  --se-success-contrast-rgb: 255, 255, 255;
  --se-information-contrast: #ffffff;
  --se-information-contrast-rgb: 255, 255, 255;
  --se-warning-contrast: #333333;
  --se-warning-contrast-rgb: 51, 51, 51;
  --se-error-contrast: #ffffff;
  --se-error-contrast-rgb: 255, 255, 255;
  --se-primary-hover: #32ad3c;
  --se-primary-hover-rgb: 50, 173, 60;
  --se-secondary-hover: #0087cd;
  --se-secondary-hover-rgb: 0, 135, 205;
  --se-standard-hover: #494b50;
  --se-standard-hover-rgb: 73, 75, 80;
  --se-alternative-hover: #e6e6e6;
  --se-alternative-hover-rgb: 230, 230, 230;
  --se-primary-selected: #0a9a25;
  --se-primary-selected-rgb: 10, 154, 37;
  --se-secondary-selected: #0f81b3;
  --se-secondary-selected-rgb: 15, 129, 179;
  --se-standard-selected: #2f3136;
  --se-standard-selected-rgb: 47, 49, 54;
  --se-alternative-selected: #cccccc;
  --se-alternative-selected-rgb: 204, 204, 204;
  --se-button-focus: #007acd;
  --se-button-focus-rgb: 0, 122, 205;
  --se-background-standard: #f7f7f7;
  --se-background-standard-rgb: 247, 247, 247;
  --se-background-standard-contrast: #333333;
  --se-background-standard-contrast-rgb: 51, 51, 51;
  --se-background-alternative: #ffffff;
  --se-background-alternative-rgb: 255, 255, 255;
  --se-background-alternative-contrast: #333333;
  --se-background-alternative-contrast-rgb: 51, 51, 51;
  --se-background-footer: #e7e6e6;
  --se-background-footer-rgb: 231, 230, 230;
  --se-background-footer-contrast: #333333;
  --se-background-footer-contrast-rgb: 51, 51, 51;
  --se-overlay: rgba(15, 15, 15, 0.4);
  --se-overlay-rgb: 15, 15, 15;
  --se-overlay-loading: rgba(255, 255, 255, 0.4);
  --se-overlay-loading-rgb: 255, 255, 255;
  --se-shadow: rgba(15, 15, 15, 0.2);
  --se-shadow-rgb: 15, 15, 15;
}